import axios from "axios";
import { ElMessage } from 'element-plus'

// 获取品牌列表
export async function getBrandListFun(params) {
    return new Promise((resolve, reject) => {
        let url = '/api/bms/hotBrandConfig/list?';
        for (let i = 0; i < params.keys.length; i++) {
            const key = params.keys[i];
            if (params.formValue[key]) {
                if (i != 0) {
                    url += '&';
                }
                url += `${key}=${params.formValue[key]}`;
            }
        }
        axios.get(url).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 添加品牌
export async function brandAddFun(params) {
    return new Promise((resolve, reject) => {
        axios.post("/api/bms/hotBrandConfig/add", params).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 删除品牌
export async function deleteFun(id) {
    return new Promise((resolve, reject) => {
        axios.post(`/api/bms/hotBrandConfig/del/${id}`).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
                ElMessage({
                    showClose: true,
                    message: res.data.msg,
                    type: 'success',
                })
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}
// 查询第三方品牌列表
export async function getThirdBrand() {
    return new Promise((resolve, reject) => {
        axios.get(`/api/vf/getBrand`).then((res) => {
            if (res.data.code == 200) {
                resolve(res.data);
            } else {
                reject();
            }
        }).catch(err => {
            reject(err);
        })
    })
}